import teamMembers from './team-members.js';
import teamMemberPayrollAllowances from './team-member-payroll-allowances.js';
import payrolls from './payrolls.js';
import teamMemberDeductions from './team-member-deductions.js';
// import payrollOrganizationContributions from './payroll-organization-contributions.js';

export default [
    ...teamMembers,
    ...teamMemberPayrollAllowances,
    ...payrolls,
    ...teamMemberDeductions,
    //     ...payrollOrganizationContributions,
];
